export const brandsToExclude = [
  "ACTEMRA",
  "ACTEMRA®",
  "Aqualyx®",
  "AQUALYX®",
  "Azzalure®",
  "AZZALURE®",
  "Belkyra",
  "BELKYRA™",
  "Benlysta",
  "Bocouture®",
  "BOCOUTURE® (XEOMIN®)",
  "Botulax®",
  "BOTULAX®",
  "Botox®",
  "BOTOX®",
  "Cimzia",
  "CIMZIA®",
  "Depo-Provera®",
  "Depo-provera",
  "DEPO-PROVERA®",
  "Dysline",
  "Dysport®",
  "DYSPORT®",
  "Eylea®",
  "EYLEA®",
  "Emla™",
  "EMLA™",
  "Entyvio",
  "ENTYVIO®",
  "Eurogine",
  "EVENITY®",
  "EVENITY",
  "Gardasil®",
  "GARDASIL®",
  "Hynidase",
  "HYNIDASE®",
  "Innotox",
  "Innotox®",
  "INNOTOX®",
  "Jaydess®",
  "JAYDESS®",
  "Liporase",
  "LIPORASE®",
  "Liztox",
  "LIZTOX®",
  "Liztox®",
  "Lumigan",
  "LUMIGAN®",
  "LATISSE®",
  "Mabthera",
  "MABTHERA®",
  "Medical Devices",
  "Meditoxin®",
  "MEDITOXIN®",
  "Mirena®",
  "MIRENA®",
  "Nabota",
  "NABOTA® (JEUVEAU®)",
  "Nexplanon",
  "Nexplanon®",
  "NEXPLANON®",
  "Orencia®",
  "ORENCIA®",
  "Ozempic",
  "OZEMPIC®",
  "Pharmaceuticals",
  "Prolia®",
  "PROLIA®",
  "Re N Tox™",
  "Re n tox",
  "Remicade®",
  "REMICADE®",
  "Restasis",
  "Rybelsus",
  "Saxenda®",
  "SAXENDA®",
  "SMB®",
  "SMB",
  "Tobradex®",
  "TOBRADEX®",
  "TYSABRI",
  "Tysabri",
  "T-SAFE®",
  "T-SAFE",
  "Unlicensed",
  "Vabysmo",
  "VABYSMO®",
  "Vistabex",
  "Wegovy",
  "WEGOVY®",
  "Xeomin®",
  "XEOMIN®",
  "XOLAIR®",
  "XEOMEEN®",
  "XEOMEEN",
  "xeomeen"
];

export const categoriesToExclude = [
  "Botulinum Toxins",
  "Botulinum",
  "Gynecology",
  "Optical",
  "Weight Management",
  "Weight Loss",
  "Vaccine",
  "Rheumatology",
  "Topical Anaesthetic",
  "Anaesthetics",
  "Filler Removal",
  "Dermal Filler Removal",
  "Ophthalmology",
  "Dermal Filler Removal",
  "Osteoporosis",
  "Asthma",
];
